import { flFetch as fetch, validateStatus } from "./fetch";

export const updateDispute = (faxId, data) => {
  return fetch(`${process.env.REACT_APP_API_URL}/jobs/faxes/dispute/${faxId}`, {
    method: "PUT",
    body: JSON.stringify(data)
  }).then(validateStatus);
};
